module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAMAAADzapwJAAAANlBMVEUAAADxmKfxmKfxmKfxmKfxmKfxmKfxmKfxmKfxmKfxmKfxmKfxmKfxmKfxmKfxmKfxmKfxmKcKlY4MAAAAEXRSTlMAcI4FQYD37ujex5mJd0hhYBZKnOQAAAB7SURBVBjTdZFZDsQgDMWSBrpvvv9lRw0DopXiH+AhDCHyx5LuuyaTHssLzpK7jXOmMZ81vXlxlzTxIbl3hHWr0bbC+PgzMIjiqAxAFrGpLLUbJnNzCWrq9oN2vKk43AXu7+ZBHEiCK4MHBuUExQdf9XDx4graEDctaPEP8O8TJ0nUnQkAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gb.png
// module id = S3ng
// module chunks = 1